// ======================================================================
// File: src/modules/ppe/components/orders/OrdersKpiBar.js
// ======================================================================

import React from "react";

const Card = ({ title, value, gradient }) => (
  <div
    className="card text-white"
    style={{
      background: gradient,
      borderRadius: 10,
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
    }}
  >
    <div className="card-body">
      <div style={{ fontSize: 26, fontWeight: 700 }}>{value}</div>
      <div style={{ fontSize: 13, opacity: 0.9 }}>{title}</div>
      <div style={{ fontSize: 11, opacity: 0.75 }}>Current View</div>
    </div>
  </div>
);

export default function OrdersKpiBar({ rows }) {
  const total = rows.length;
  const draft = rows.filter((r) => r.status === "DRAFT").length;
  const inProgress = rows.filter((r) => r.status === "IN_PROGRESS").length;
  const completed = rows.filter((r) => r.status === "COMPLETED").length;

  return (
    <div className="row g-3 mb-3">
      <div className="col-md-3">
        <Card
          title="Total Orders"
          value={total}
          gradient="linear-gradient(135deg, #6a11cb, #2575fc)"
        />
      </div>
      <div className="col-md-3">
        <Card
          title="Draft"
          value={draft}
          gradient="linear-gradient(135deg, #757f9a, #d7dde8)"
        />
      </div>
      <div className="col-md-3">
        <Card
          title="In Progress"
          value={inProgress}
          gradient="linear-gradient(135deg, #f7971e, #ffd200)"
        />
      </div>
      <div className="col-md-3">
        <Card
          title="Completed"
          value={completed}
          gradient="linear-gradient(135deg, #11998e, #38ef7d)"
        />
      </div>
    </div>
  );
}
